<template>
  <div class="max-w-lg relative">
    <div class="mt-1 flex rounded-md">
      <div class="relative flex-grow focus-within:z-10">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg
            v-if="!searchLoading"
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-gray-400"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" />
            <circle cx="10" cy="10" r="7" />
            <line x1="21" y1="21" x2="15" y2="15" />
          </svg>
          <div v-else class="spinner"></div>
        </div>
        <input
          id="search"
          v-model="search"
          autocomplete="off"
          type="text"
          class="focus:ring-slate-500 focus:border-slate-300 block w-full pl-10 sm:text-sm border-slate-300 rounded-md"
          placeholder="Search..."
          @input="searchLoading = true"
        />
      </div>
    </div>
    <div v-if="data.length > 0 && search" class="z-10 absolute mt-1 w-full rounded-md bg-white border border-slate-200">
      <ul
        tabindex="-1"
        role="listbox"
        aria-labelledby="listbox-label"
        aria-activedescendant="listbox-item-3"
        class="max-h-60 rounded-md py-1 text-base leading-6 overflow-auto focus:outline-none sm:text-sm sm:leading-5"
      >
        <a v-for="option of data" :key="option.url" :href="option.url">
          <li
            id=":option"
            role="option"
            class="cursor-pointer hover:bg-indigo-600 hover:text-white text-gray-900 select-none relative py-2 pl-3 pr-9"
          >
            <span class="font-normal inline-block">
              <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-5 text-gray-400">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                ></path>
              </svg>
            </span>
            <span class="ml-4 font-normal inline-block truncate">
              {{ option.name }}
            </span>
          </li>
        </a>

        <!-- More options... -->
      </ul>
    </div>
  </div>
</template>

<script>
import { debounce } from '../../utilities/debounce';

export default {
  data() {
    return {
      searchLoading: false,
      search: '',
      debouncedInput: '',
      data: [],
    };
  },
  methods: {
    searchQuery() {
      const self = this;
      fetch(`/api/search?query=${self.debouncedInput}`)
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.searchLoading = false;
          let responseData = [];
          for (let contact of data.contacts) {
            responseData.push({
              name: contact.name,
              url: contact.record_type == 'Teammate' ? `/team/${contact.id}` : `/contacts/${contact.id}`,
            });
          }
          self.data = responseData;
        });
    },
  },
  watch: {
    search: debounce(function (newVal) {
      this.debouncedInput = newVal;
    }, 500),
    debouncedInput() {
      if (this.debouncedInput) {
        this.searchQuery();
      } else {
        this.searchLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.spinner {
  height: 22px;
  width: 22px;
  animation: rotateSpinner 0.8s infinite linear;
  border: 2px solid black;
  border-right-color: transparent;
  border-radius: 50%;
  z-index: 50;
}

@keyframes rotateSpinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Override input padding for this search component */
input[type='text'] {
  padding-left: 2.5rem;
}
</style>
